import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutRoutingModule } from './layout-routing.module';
import { BaseComponent } from './components/base/base.component';
import { HeaderComponent } from './components/header/header.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
@NgModule({
  declarations: [BaseComponent, HeaderComponent],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    SharedModule,
    MatMenuModule,
    MatSidenavModule,
  ],
  exports: [HeaderComponent],
})
export class LayoutModule {}
